module.exports = __webpack_public_path__ + "img/home-blue.f8071c54.png";